module.exports = __webpack_public_path__ + "img/75635.442ef802.svg";